import { useSelector } from 'react-redux'

// to move to BE per AT-297
const OTSUKA_ORGANIZATION_IDS = ['6824e1ffcbee2cb229ca365a', '68deeaeb702dd2062ca3514f']

export const useIsOtsukaOrganization = () => {
    // @ts-expect-error redux store's state is not properly typed
    const userRecordOrganizationId = useSelector((state) => state?.userRecord?.organizationId)
    // @ts-expect-error redux store's state is not properly typed
    const strategyOrganizationId = useSelector((state) => state?.strategy?.organizationId)

    const isOtsukaOrganization =
        OTSUKA_ORGANIZATION_IDS.includes(userRecordOrganizationId) ||
        OTSUKA_ORGANIZATION_IDS.includes(strategyOrganizationId)

    return isOtsukaOrganization
}
